import { NavLink, useParams } from "react-router";
import { ChevronLeft } from "lucide-react";
import t from "@/lang/lang";
import { Button } from "@/shared/components/ui/button";
import { MasterDataPdfGeneralCard } from "@/services/backend/company/components/master-data-pdf-general-card";
import { MasterDataPdfAddressDataCard } from "@/services/backend/company/components/master-data-pdf-address-data-card";
import { MasterDataPdfHeaderDataCard } from "@/services/backend/company/components/master-data-pdf-header-data-card";
import { MasterDataPdfFooterDataCard } from "@/services/backend/company/components/master-data-pdf-footer-data-card";
import { MasterDataPdfInfoblockDataCard } from "@/services/backend/company/components/master-data-pdf-infoblock-data-card";

export function CompanyMasterDataPdfEditRoute() {
  const { masterDataPdfId } = useParams();

  return (
    <div className="grid gap-2">
      <div>
        <Button variant="link" size="sm" asChild>
          <NavLink to="..">
            <ChevronLeft className="h-4 w-4" />
            {t("Alle PDF-Template-Daten")}
          </NavLink>
        </Button>
      </div>
      <MasterDataPdfGeneralCard id={masterDataPdfId!} />
      <MasterDataPdfAddressDataCard id={masterDataPdfId!} />
      <MasterDataPdfHeaderDataCard id={masterDataPdfId!} />
      <MasterDataPdfFooterDataCard id={masterDataPdfId!} />
      <MasterDataPdfInfoblockDataCard id={masterDataPdfId!} />
    </div>
  );
}
